// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("HUB_Icons.eot?yump9o", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("HUB_Icons.ttf?yump9o", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("HUB_Icons.woff?yump9o", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("HUB_Icons.svg?yump9o", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#HUB_Icons" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'HUB_Icons';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="hubicon-"], [class*=" hubicon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'HUB_Icons' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.hubicon-add_circle:before {
  content: "\\e969";
  color: #71847b;
}
.hubicon-video_library:before {
  content: "\\e968";
  color: #4d5451;
}
.hubicon-assignment_ind:before {
  content: "\\e951";
  color: #71847b;
}
.hubicon-settings:before {
  content: "\\e950";
  color: #30b36b;
}
.hubicon-new_page .path1:before {
  content: "\\e94a";
  color: rgb(48, 179, 107);
}
.hubicon-new_page .path2:before {
  content: "\\e94b";
  margin-left: -1.224609375em;
  color: rgb(48, 179, 107);
}
.hubicon-new_page .path3:before {
  content: "\\e94c";
  margin-left: -1.224609375em;
  color: rgb(48, 179, 107);
}
.hubicon-new_page .path4:before {
  content: "\\e94d";
  margin-left: -1.224609375em;
  color: rgb(48, 179, 107);
}
.hubicon-new_page .path5:before {
  content: "\\e94e";
  margin-left: -1.224609375em;
  color: rgb(255, 255, 255);
}
.hubicon-new_page .path6:before {
  content: "\\e94f";
  margin-left: -1.224609375em;
  color: rgb(48, 179, 107);
}
.hubicon-payments:before {
  content: "\\e948";
}
.hubicon-payments_fill:before {
  content: "\\e949";
}
.hubicon-cancel:before {
  content: "\\e944";
  color: #b4b4b4;
}
.hubicon-check_circle:before {
  content: "\\e945";
  color: #57d17d;
}
.hubicon-delete:before {
  content: "\\e946";
  color: #71847b;
}
.hubicon-edit:before {
  content: "\\e947";
  color: #71847b;
}
.hubicon-expand_more:before {
  content: "\\e943";
}
.hubicon-code:before {
  content: "\\e942";
}
.hubicon-explore:before {
  content: "\\e941";
}
.hubicon-check:before {
  content: "\\e940";
}
.hubicon-change_circle:before {
  content: "\\e93f";
}
.hubicon-confirmation_number:before {
  content: "\\e937";
}
.hubicon-confirmation_number-1:before {
  content: "\\e938";
}
.hubicon-forward_to_inbox:before {
  content: "\\e939";
}
.hubicon-forward_to_inbox-1:before {
  content: "\\e93a";
}
.hubicon-home:before {
  content: "\\e93b";
}
.hubicon-home-1:before {
  content: "\\e93c";
}
.hubicon-manage_accounts1:before {
  content: "\\e93d";
}
.hubicon-manage_accounts-1:before {
  content: "\\e93e";
}
.hubicon-share_v2:before {
  content: "\\e936";
}
.hubicon-share .path1:before {
  content: "\\e934";
  color: rgb(110, 114, 110);
}
.hubicon-share .path2:before {
  content: "\\e935";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-menu:before {
  content: "\\e933";
}
.hubicon-follow_respon .path1:before {
  content: "\\e92d";
  color: rgb(255, 255, 255);
}
.hubicon-follow_respon .path2:before {
  content: "\\e92e";
  margin-left: -1em;
  color: rgb(48, 179, 107);
}
.hubicon-follow_respon .path3:before {
  content: "\\e92f";
  margin-left: -1em;
  color: rgb(48, 179, 107);
}
.hubicon-following_respon .path1:before {
  content: "\\e929";
  color: rgb(48, 179, 107);
}
.hubicon-following_respon .path2:before {
  content: "\\e92a";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-following_respon .path3:before {
  content: "\\e92b";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-following_respon .path4:before {
  content: "\\e92c";
  margin-left: -1em;
  color: rgb(48, 179, 107);
}
.hubicon-Frame-1531:before {
  content: "\\e930";
  color: #4d5451;
}
.hubicon-manage_accounts:before {
  content: "\\e931";
}
.hubicon-smartphone:before {
  content: "\\e932";
  color: #4d5451;
}
.hubicon-stadium:before {
  content: "\\e928";
}
.hubicon-person_add:before {
  content: "\\e91b";
}
.hubicon-baloa_logo:before {
  content: "\\e91a";
  color: #30b36b;
}
.hubicon-create_team .path1:before {
  content: "\\e90b";
  color: rgb(111, 174, 153);
}
.hubicon-create_team .path2:before {
  content: "\\e90c";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-create_team .path3:before {
  content: "\\e90d";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-join_team .path1:before {
  content: "\\e90e";
  color: rgb(46, 78, 65);
}
.hubicon-join_team .path2:before {
  content: "\\e918";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-join_team .path3:before {
  content: "\\e919";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-add_option:before {
  content: "\\e91c";
}
.hubicon-dropdown:before {
  content: "\\e91d";
}
.hubicon-date:before {
  content: "\\e91e";
}
.hubicon-phone:before {
  content: "\\e91f";
}
.hubicon-check_box:before {
  content: "\\e920";
}
.hubicon-clear_option:before {
  content: "\\e921";
}
.hubicon-upload_file:before {
  content: "\\e922";
}
.hubicon-delete_question:before {
  content: "\\e923";
}
.hubicon-mail:before {
  content: "\\e924";
}
.hubicon-radio_button:before {
  content: "\\e925";
}
.hubicon-preview:before {
  content: "\\e926";
}
.hubicon-answer:before {
  content: "\\e927";
}
.hubicon-groups .path1:before {
  content: "\\e90f";
  color: rgb(235, 59, 59);
}
.hubicon-groups .path2:before {
  content: "\\e910";
  margin-left: -1.01953125em;
  color: rgb(255, 255, 255);
}
.hubicon-pages .path1:before {
  content: "\\e911";
  color: rgb(24, 193, 110);
}
.hubicon-pages .path2:before {
  content: "\\e912";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-pages .path3:before {
  content: "\\e913";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-pages .path4:before {
  content: "\\e914";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-pages .path5:before {
  content: "\\e915";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-tournaments .path1:before {
  content: "\\e916";
  color: rgb(235, 194, 0);
}
.hubicon-tournaments .path2:before {
  content: "\\e917";
  margin-left: -1.01953125em;
  color: rgb(255, 255, 255);
}
.hubicon-file_download:before {
  content: "\\e90a";
  color: #4d5451;
}
.hubicon-info:before {
  content: "\\e909";
  color: #4d5451;
}
.hubicon-payment_info:before {
  content: "\\e907";
  color: #71847b;
}
.hubicon-view_form:before {
  content: "\\e908";
  color: #71847b;
}
.hubicon-upload:before {
  content: "\\e906";
  color: #4d5451;
}
.hubicon-date_inscription:before {
  content: "\\e900";
  color: #71847b;
}
.hubicon-finish_date:before {
  content: "\\e901";
  color: #71847b;
}
.hubicon-inscription:before {
  content: "\\e902";
  color: #71847b;
}
.hubicon-location:before {
  content: "\\e903";
  color: #71847b;
}
.hubicon-participants:before {
  content: "\\e904";
  color: #71847b;
}
.hubicon-start_date:before {
  content: "\\e905";
  color: #71847b;
}
.hubicon-team_fill:before {
  content: "\\e952";
  color: #71847b;
}
.hubicon-tournament_fill:before {
  content: "\\e953";
  color: #71847b;
}
.hubicon-roles_fill:before {
  content: "\\e954";
  color: #71847b;
}
.hubicon-roles:before {
  content: "\\e955";
  color: #4d5451;
}
.hubicon-help_fill:before {
  content: "\\e956";
  color: #71847b;
}
.hubicon-help:before {
  content: "\\e957";
  color: #4d5451;
}
.hubicon-shuffle:before {
  content: "\\e958";
}
.hubicon-low_priority:before {
  content: "\\e959";
  color: #4d5451;
}
.hubicon-lock:before {
  content: "\\e95a";
}
.hubicon-timer:before {
  content: "\\e95b";
}
.hubicon-lock_fill:before {
  content: "\\e95c";
  color: #4d5451;
}
.hubicon-lock_open:before {
  content: "\\e95d";
  color: #4d5451;
}

.hubicon-account_circle:before {
  content: "\\e963";
  color: #4d5451;
}

.hubicon-article:before {
  content: "\\e964";
  color: #4d5451;
}

.hubicon-schedule:before {
  content: "\\e965";
  color: #4d5451;
}

.hubicon-team:before {
  content: "\\e967";
  color: #4d5451;
}

.hubicon-players:before {
  content: "\\e966";
  color: #4d5451;
}

.hubicon-money_off:before {
  content: "\\e96b";
}

.hubicon-paid:before {
  content: "\\e96a";
}

.hubicon-arrow_circle_right .path1:before {
  content: "\\e96c";
  color: rgb(113, 132, 123);
}

.hubicon-arrow_circle_right .path2:before {
  content: "\\e96d";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.hubicon-arrow_circle_left .path1:before {
  content: "\\e96e";
  color: rgb(113, 132, 123);
}

.hubicon-arrow_circle_left .path2:before {
  content: "\\e96f";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.hubicon-assists .path1:before {
  content: "\\e970";
  color: rgb(77, 84, 81);
}
.hubicon-assists .path2:before {
  content: "\\e971";
  margin-left: -1.0908203125em;
  color: rgb(77, 84, 81);
}
.hubicon-assists .path3:before {
  content: "\\e972";
  margin-left: -1.0908203125em;
  color: rgb(77, 84, 81);
}
.hubicon-assists .path4:before {
  content: "\\e973";
  margin-left: -1.0908203125em;
  color: rgb(77, 84, 81);
}
.hubicon-assists .path5:before {
  content: "\\e974";
  margin-left: -1.0908203125em;
  color: rgb(77, 84, 81);
}
.hubicon-assists .path6:before {
  content: "\\e975";
  margin-left: -1.0908203125em;
  color: rgb(255, 255, 255);
}
.hubicon-assists .path7:before {
  content: "\\e976";
  margin-left: -1.0908203125em;
  color: rgb(255, 255, 255);
}
.hubicon-goalkeeper:before {
  content: "\\e977";
}

.hubicon-titular .path1:before {
  content: "\\e978";
  color: rgb(77, 84, 81);
}
.hubicon-titular .path2:before {
  content: "\\e979";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.hubicon-play_circle:before {
  content: "\\e97a";
  color: #4d5451;
}

.hubicon-verified_modal .path1:before {
  content: "\\e961";
  color: rgb(77, 84, 81);
}
.hubicon-verified_modal .path2:before {
  content: "\\e962";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.hubicon-verified:before {
  content: "\\e960";
  color: #30b36b;
}

.hubicon-default_pp .path1:before {
  content: "\\e95e";
  color: rgb(137, 153, 168);
}
.hubicon-default_pp .path2:before {
  content: "\\e95f";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.hubicon-block:before {
  content: "\\e97b";
  /* color: #4d5451; */
}

.hubicon-how_to_reg:before {
  content: "\\e97c";
  /* color: #4d5451; */
}

.hubicon-explore_2:before {
  content: "\\e97d";
}

.hubicon-favorite:before {
  content: "\\e97e";
}

.hubicon-favorite_fill:before {
  content: "\\e97f";
}

.hubicon-ruler:before {
  content: "\\e980";
  color: #4d5451;
}
.hubicon-weight-scale:before {
  content: "\\e981";
  color: #4d5451;
}

.hubicon-all:before {
  content: "\\e982";
  color: #4d5451;
}

.hubicon-post_fill:before {
  content: "\\e983";
  color: #4d5451;
}

.hubicon-post:before {
  content: "\\e984";
  color: #4d5451;
}

.hubicon-pages_v2:before {
  content: "\\e985";
  color: #4d5451;
}

.hubicon-save:before {
  content: "\\e986";
  color: #4d5451;
}

.hubicon-roster:before {
  content: "\\e987";
  color: #4d5451;
}

.hubicon-id_card:before {
  content: "\\e988";
  color: #4d5451;
}

.hubicon-check_circle_fill:before {
  content: "\\e98d";
  color: #30b36b;
}

.hubicon-cancel_fill:before {
  content: "\\e98c";
  color: #dc3545;
}

.hubicon-event_available:before {
  content: "\\e989";
  color: #4d5451;
}

.hubicon-event_busy:before {
  content: "\\e98a";
  color: #4d5451;
}

.hubicon-shield:before {
  content: "\\e98b";
  color: #4d5451;
}

.hubicon-open_in_new:before {
  content: "\\e98e";
}

.hubicon-video_camera_front:before {
  content: "\\e98f";
}

.hubicon-share_reviews:before {
  content: "\\e997";
  color: #d63384;
}

.hubicon-live_tv:before {
  content: "\\e996";
  color: #30b36b;
}

.hubicon-link:before {
  content: "\\e995";
  color: #0aa2c0;
}

.hubicon-close:before {
  content: "\\e994";
  color: #dc3545;
}

.hubicon-check1:before {
  content: "\\e993";
  color: #30b36b;
}

.hubicon-casino:before {
  content: "\\e992";
}

.hubicon-bar_chart_4_bars:before {
  content: "\\e991";
  color: #dc3545;
}

.hubicon-award_star:before {
  content: "\\e990";
  color: #e9c73b;
}

.hubicon-live_tv1:before {
  content: "\\e99a";
}

.hubicon-live_tv-1:before {
  content: "\\e99b";
}

.hubicon-sensors:before {
  content: "\\e99c";
  /* color: #4d5451; */
}

.hubicon-sync_saved_locally:before {
  content: "\\e99d";
  /* color: #4d5451; */
}

.hubicon-sync_saved_locally-1:before {
  content: "\\e99e";
}

.hubicon-public:before {
  content: "\\e99f";
  color: #4d5451;
}

.hubicon-public_off:before {
  content: "\\e9a0";
  color: #4d5451;
}

.hubicon-video_library1:before {
  content: "\\e9a2";
  color: #4d5451;
}

.hubicon-video_library-1:before {
  content: "\\e9a3";
  color: #4d5451;
}

.hubicon-play_arrow:before {
  content: "\\e9a1";
}

.hubicon-download:before {
  content: "\\e9a4";
}

.hubicon-edit1:before {
  content: "\\e9a5";
}

.hubicon-play_circle1:before {
  content: "\\e9a6";
}

.hubicon-video_camera_front1:before {
  content: "\\e9a7";
}

.hubicon-stop_circle:before {
  content: "\\e9a8";
  color: #4d5451;
}

.hubicon-photo:before {
  content: "\\e9a9";
  color: #4d5451;
}

.hubicon-diversity_3:before {
  content: "\\e9aa";
  color: #4d5451;
}
.hubicon-groups1:before {
  content: "\\e9ab";
  color: #4d5451;
}
.hubicon-person:before {
  content: "\\e9ac";
  color: #4d5451;
}

.hubicon-link_off:before {
  content: "\\e9ae";
}

.hubicon-arrow_outward:before {
  content: "\\e9af";
}

.hubicon-sports_and_outdoors:before {
  content: "\\e9b0";
}

.hubicon-info_v2:before {
  content: "\\e9b2";
}

.hubicon-deletev2:before {
  content: "\\e9b1";
  color: #4d5451;
}

.hubicon-gavel:before {
  content: "\\e9b3";
}

.hubicon-dashboard_customize:before {
  content: "\\e9b4";
  color: #6ea8fe;
}

.hubicon-campaign:before {
  content: "\\e9b5";
}

.hubicon-task_alt:before {
  content: "\\e9b6";
  color: #4d5451;
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/HubIcons.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,6CAAiC;EACjC;;;yDAGqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["@font-face {\n  font-family: 'HUB_Icons';\n  src:  url('HUB_Icons.eot?yump9o');\n  src:  url('HUB_Icons.eot?yump9o#iefix') format('embedded-opentype'),\n    url('HUB_Icons.ttf?yump9o') format('truetype'),\n    url('HUB_Icons.woff?yump9o') format('woff'),\n    url('HUB_Icons.svg?yump9o#HUB_Icons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"hubicon-\"], [class*=\" hubicon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'HUB_Icons' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.hubicon-add_circle:before {\n  content: \"\\e969\";\n  color: #71847b;\n}\n.hubicon-video_library:before {\n  content: \"\\e968\";\n  color: #4d5451;\n}\n.hubicon-assignment_ind:before {\n  content: \"\\e951\";\n  color: #71847b;\n}\n.hubicon-settings:before {\n  content: \"\\e950\";\n  color: #30b36b;\n}\n.hubicon-new_page .path1:before {\n  content: \"\\e94a\";\n  color: rgb(48, 179, 107);\n}\n.hubicon-new_page .path2:before {\n  content: \"\\e94b\";\n  margin-left: -1.224609375em;\n  color: rgb(48, 179, 107);\n}\n.hubicon-new_page .path3:before {\n  content: \"\\e94c\";\n  margin-left: -1.224609375em;\n  color: rgb(48, 179, 107);\n}\n.hubicon-new_page .path4:before {\n  content: \"\\e94d\";\n  margin-left: -1.224609375em;\n  color: rgb(48, 179, 107);\n}\n.hubicon-new_page .path5:before {\n  content: \"\\e94e\";\n  margin-left: -1.224609375em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-new_page .path6:before {\n  content: \"\\e94f\";\n  margin-left: -1.224609375em;\n  color: rgb(48, 179, 107);\n}\n.hubicon-payments:before {\n  content: \"\\e948\";\n}\n.hubicon-payments_fill:before {\n  content: \"\\e949\";\n}\n.hubicon-cancel:before {\n  content: \"\\e944\";\n  color: #b4b4b4;\n}\n.hubicon-check_circle:before {\n  content: \"\\e945\";\n  color: #57d17d;\n}\n.hubicon-delete:before {\n  content: \"\\e946\";\n  color: #71847b;\n}\n.hubicon-edit:before {\n  content: \"\\e947\";\n  color: #71847b;\n}\n.hubicon-expand_more:before {\n  content: \"\\e943\";\n}\n.hubicon-code:before {\n  content: \"\\e942\";\n}\n.hubicon-explore:before {\n  content: \"\\e941\";\n}\n.hubicon-check:before {\n  content: \"\\e940\";\n}\n.hubicon-change_circle:before {\n  content: \"\\e93f\";\n}\n.hubicon-confirmation_number:before {\n  content: \"\\e937\";\n}\n.hubicon-confirmation_number-1:before {\n  content: \"\\e938\";\n}\n.hubicon-forward_to_inbox:before {\n  content: \"\\e939\";\n}\n.hubicon-forward_to_inbox-1:before {\n  content: \"\\e93a\";\n}\n.hubicon-home:before {\n  content: \"\\e93b\";\n}\n.hubicon-home-1:before {\n  content: \"\\e93c\";\n}\n.hubicon-manage_accounts1:before {\n  content: \"\\e93d\";\n}\n.hubicon-manage_accounts-1:before {\n  content: \"\\e93e\";\n}\n.hubicon-share_v2:before {\n  content: \"\\e936\";\n}\n.hubicon-share .path1:before {\n  content: \"\\e934\";\n  color: rgb(110, 114, 110);\n}\n.hubicon-share .path2:before {\n  content: \"\\e935\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-menu:before {\n  content: \"\\e933\";\n}\n.hubicon-follow_respon .path1:before {\n  content: \"\\e92d\";\n  color: rgb(255, 255, 255);\n}\n.hubicon-follow_respon .path2:before {\n  content: \"\\e92e\";\n  margin-left: -1em;\n  color: rgb(48, 179, 107);\n}\n.hubicon-follow_respon .path3:before {\n  content: \"\\e92f\";\n  margin-left: -1em;\n  color: rgb(48, 179, 107);\n}\n.hubicon-following_respon .path1:before {\n  content: \"\\e929\";\n  color: rgb(48, 179, 107);\n}\n.hubicon-following_respon .path2:before {\n  content: \"\\e92a\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-following_respon .path3:before {\n  content: \"\\e92b\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-following_respon .path4:before {\n  content: \"\\e92c\";\n  margin-left: -1em;\n  color: rgb(48, 179, 107);\n}\n.hubicon-Frame-1531:before {\n  content: \"\\e930\";\n  color: #4d5451;\n}\n.hubicon-manage_accounts:before {\n  content: \"\\e931\";\n}\n.hubicon-smartphone:before {\n  content: \"\\e932\";\n  color: #4d5451;\n}\n.hubicon-stadium:before {\n  content: \"\\e928\";\n}\n.hubicon-person_add:before {\n  content: \"\\e91b\";\n}\n.hubicon-baloa_logo:before {\n  content: \"\\e91a\";\n  color: #30b36b;\n}\n.hubicon-create_team .path1:before {\n  content: \"\\e90b\";\n  color: rgb(111, 174, 153);\n}\n.hubicon-create_team .path2:before {\n  content: \"\\e90c\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-create_team .path3:before {\n  content: \"\\e90d\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-join_team .path1:before {\n  content: \"\\e90e\";\n  color: rgb(46, 78, 65);\n}\n.hubicon-join_team .path2:before {\n  content: \"\\e918\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-join_team .path3:before {\n  content: \"\\e919\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-add_option:before {\n  content: \"\\e91c\";\n}\n.hubicon-dropdown:before {\n  content: \"\\e91d\";\n}\n.hubicon-date:before {\n  content: \"\\e91e\";\n}\n.hubicon-phone:before {\n  content: \"\\e91f\";\n}\n.hubicon-check_box:before {\n  content: \"\\e920\";\n}\n.hubicon-clear_option:before {\n  content: \"\\e921\";\n}\n.hubicon-upload_file:before {\n  content: \"\\e922\";\n}\n.hubicon-delete_question:before {\n  content: \"\\e923\";\n}\n.hubicon-mail:before {\n  content: \"\\e924\";\n}\n.hubicon-radio_button:before {\n  content: \"\\e925\";\n}\n.hubicon-preview:before {\n  content: \"\\e926\";\n}\n.hubicon-answer:before {\n  content: \"\\e927\";\n}\n.hubicon-groups .path1:before {\n  content: \"\\e90f\";\n  color: rgb(235, 59, 59);\n}\n.hubicon-groups .path2:before {\n  content: \"\\e910\";\n  margin-left: -1.01953125em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-pages .path1:before {\n  content: \"\\e911\";\n  color: rgb(24, 193, 110);\n}\n.hubicon-pages .path2:before {\n  content: \"\\e912\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-pages .path3:before {\n  content: \"\\e913\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-pages .path4:before {\n  content: \"\\e914\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-pages .path5:before {\n  content: \"\\e915\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-tournaments .path1:before {\n  content: \"\\e916\";\n  color: rgb(235, 194, 0);\n}\n.hubicon-tournaments .path2:before {\n  content: \"\\e917\";\n  margin-left: -1.01953125em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-file_download:before {\n  content: \"\\e90a\";\n  color: #4d5451;\n}\n.hubicon-info:before {\n  content: \"\\e909\";\n  color: #4d5451;\n}\n.hubicon-payment_info:before {\n  content: \"\\e907\";\n  color: #71847b;\n}\n.hubicon-view_form:before {\n  content: \"\\e908\";\n  color: #71847b;\n}\n.hubicon-upload:before {\n  content: \"\\e906\";\n  color: #4d5451;\n}\n.hubicon-date_inscription:before {\n  content: \"\\e900\";\n  color: #71847b;\n}\n.hubicon-finish_date:before {\n  content: \"\\e901\";\n  color: #71847b;\n}\n.hubicon-inscription:before {\n  content: \"\\e902\";\n  color: #71847b;\n}\n.hubicon-location:before {\n  content: \"\\e903\";\n  color: #71847b;\n}\n.hubicon-participants:before {\n  content: \"\\e904\";\n  color: #71847b;\n}\n.hubicon-start_date:before {\n  content: \"\\e905\";\n  color: #71847b;\n}\n.hubicon-team_fill:before {\n  content: \"\\e952\";\n  color: #71847b;\n}\n.hubicon-tournament_fill:before {\n  content: \"\\e953\";\n  color: #71847b;\n}\n.hubicon-roles_fill:before {\n  content: \"\\e954\";\n  color: #71847b;\n}\n.hubicon-roles:before {\n  content: \"\\e955\";\n  color: #4d5451;\n}\n.hubicon-help_fill:before {\n  content: \"\\e956\";\n  color: #71847b;\n}\n.hubicon-help:before {\n  content: \"\\e957\";\n  color: #4d5451;\n}\n.hubicon-shuffle:before {\n  content: \"\\e958\";\n}\n.hubicon-low_priority:before {\n  content: \"\\e959\";\n  color: #4d5451;\n}\n.hubicon-lock:before {\n  content: \"\\e95a\";\n}\n.hubicon-timer:before {\n  content: \"\\e95b\";\n}\n.hubicon-lock_fill:before {\n  content: \"\\e95c\";\n  color: #4d5451;\n}\n.hubicon-lock_open:before {\n  content: \"\\e95d\";\n  color: #4d5451;\n}\n\n.hubicon-account_circle:before {\n  content: \"\\e963\";\n  color: #4d5451;\n}\n\n.hubicon-article:before {\n  content: \"\\e964\";\n  color: #4d5451;\n}\n\n.hubicon-schedule:before {\n  content: \"\\e965\";\n  color: #4d5451;\n}\n\n.hubicon-team:before {\n  content: \"\\e967\";\n  color: #4d5451;\n}\n\n.hubicon-players:before {\n  content: \"\\e966\";\n  color: #4d5451;\n}\n\n.hubicon-money_off:before {\n  content: \"\\e96b\";\n}\n\n.hubicon-paid:before {\n  content: \"\\e96a\";\n}\n\n.hubicon-arrow_circle_right .path1:before {\n  content: \"\\e96c\";\n  color: rgb(113, 132, 123);\n}\n\n.hubicon-arrow_circle_right .path2:before {\n  content: \"\\e96d\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n\n.hubicon-arrow_circle_left .path1:before {\n  content: \"\\e96e\";\n  color: rgb(113, 132, 123);\n}\n\n.hubicon-arrow_circle_left .path2:before {\n  content: \"\\e96f\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n\n.hubicon-assists .path1:before {\n  content: \"\\e970\";\n  color: rgb(77, 84, 81);\n}\n.hubicon-assists .path2:before {\n  content: \"\\e971\";\n  margin-left: -1.0908203125em;\n  color: rgb(77, 84, 81);\n}\n.hubicon-assists .path3:before {\n  content: \"\\e972\";\n  margin-left: -1.0908203125em;\n  color: rgb(77, 84, 81);\n}\n.hubicon-assists .path4:before {\n  content: \"\\e973\";\n  margin-left: -1.0908203125em;\n  color: rgb(77, 84, 81);\n}\n.hubicon-assists .path5:before {\n  content: \"\\e974\";\n  margin-left: -1.0908203125em;\n  color: rgb(77, 84, 81);\n}\n.hubicon-assists .path6:before {\n  content: \"\\e975\";\n  margin-left: -1.0908203125em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-assists .path7:before {\n  content: \"\\e976\";\n  margin-left: -1.0908203125em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-goalkeeper:before {\n  content: \"\\e977\";\n}\n\n.hubicon-titular .path1:before {\n  content: \"\\e978\";\n  color: rgb(77, 84, 81);\n}\n.hubicon-titular .path2:before {\n  content: \"\\e979\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n\n.hubicon-play_circle:before {\n  content: \"\\e97a\";\n  color: #4d5451;\n}\n\n.hubicon-verified_modal .path1:before {\n  content: \"\\e961\";\n  color: rgb(77, 84, 81);\n}\n.hubicon-verified_modal .path2:before {\n  content: \"\\e962\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.hubicon-verified:before {\n  content: \"\\e960\";\n  color: #30b36b;\n}\n\n.hubicon-default_pp .path1:before {\n  content: \"\\e95e\";\n  color: rgb(137, 153, 168);\n}\n.hubicon-default_pp .path2:before {\n  content: \"\\e95f\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n\n.hubicon-block:before {\n  content: \"\\e97b\";\n  /* color: #4d5451; */\n}\n\n.hubicon-how_to_reg:before {\n  content: \"\\e97c\";\n  /* color: #4d5451; */\n}\n\n.hubicon-explore_2:before {\n  content: \"\\e97d\";\n}\n\n.hubicon-favorite:before {\n  content: \"\\e97e\";\n}\n\n.hubicon-favorite_fill:before {\n  content: \"\\e97f\";\n}\n\n.hubicon-ruler:before {\n  content: \"\\e980\";\n  color: #4d5451;\n}\n.hubicon-weight-scale:before {\n  content: \"\\e981\";\n  color: #4d5451;\n}\n\n.hubicon-all:before {\n  content: \"\\e982\";\n  color: #4d5451;\n}\n\n.hubicon-post_fill:before {\n  content: \"\\e983\";\n  color: #4d5451;\n}\n\n.hubicon-post:before {\n  content: \"\\e984\";\n  color: #4d5451;\n}\n\n.hubicon-pages_v2:before {\n  content: \"\\e985\";\n  color: #4d5451;\n}\n\n.hubicon-save:before {\n  content: \"\\e986\";\n  color: #4d5451;\n}\n\n.hubicon-roster:before {\n  content: \"\\e987\";\n  color: #4d5451;\n}\n\n.hubicon-id_card:before {\n  content: \"\\e988\";\n  color: #4d5451;\n}\n\n.hubicon-check_circle_fill:before {\n  content: \"\\e98d\";\n  color: #30b36b;\n}\n\n.hubicon-cancel_fill:before {\n  content: \"\\e98c\";\n  color: #dc3545;\n}\n\n.hubicon-event_available:before {\n  content: \"\\e989\";\n  color: #4d5451;\n}\n\n.hubicon-event_busy:before {\n  content: \"\\e98a\";\n  color: #4d5451;\n}\n\n.hubicon-shield:before {\n  content: \"\\e98b\";\n  color: #4d5451;\n}\n\n.hubicon-open_in_new:before {\n  content: \"\\e98e\";\n}\n\n.hubicon-video_camera_front:before {\n  content: \"\\e98f\";\n}\n\n.hubicon-share_reviews:before {\n  content: \"\\e997\";\n  color: #d63384;\n}\n\n.hubicon-live_tv:before {\n  content: \"\\e996\";\n  color: #30b36b;\n}\n\n.hubicon-link:before {\n  content: \"\\e995\";\n  color: #0aa2c0;\n}\n\n.hubicon-close:before {\n  content: \"\\e994\";\n  color: #dc3545;\n}\n\n.hubicon-check1:before {\n  content: \"\\e993\";\n  color: #30b36b;\n}\n\n.hubicon-casino:before {\n  content: \"\\e992\";\n}\n\n.hubicon-bar_chart_4_bars:before {\n  content: \"\\e991\";\n  color: #dc3545;\n}\n\n.hubicon-award_star:before {\n  content: \"\\e990\";\n  color: #e9c73b;\n}\n\n.hubicon-live_tv1:before {\n  content: \"\\e99a\";\n}\n\n.hubicon-live_tv-1:before {\n  content: \"\\e99b\";\n}\n\n.hubicon-sensors:before {\n  content: \"\\e99c\";\n  /* color: #4d5451; */\n}\n\n.hubicon-sync_saved_locally:before {\n  content: \"\\e99d\";\n  /* color: #4d5451; */\n}\n\n.hubicon-sync_saved_locally-1:before {\n  content: \"\\e99e\";\n}\n\n.hubicon-public:before {\n  content: \"\\e99f\";\n  color: #4d5451;\n}\n\n.hubicon-public_off:before {\n  content: \"\\e9a0\";\n  color: #4d5451;\n}\n\n.hubicon-video_library1:before {\n  content: \"\\e9a2\";\n  color: #4d5451;\n}\n\n.hubicon-video_library-1:before {\n  content: \"\\e9a3\";\n  color: #4d5451;\n}\n\n.hubicon-play_arrow:before {\n  content: \"\\e9a1\";\n}\n\n.hubicon-download:before {\n  content: \"\\e9a4\";\n}\n\n.hubicon-edit1:before {\n  content: \"\\e9a5\";\n}\n\n.hubicon-play_circle1:before {\n  content: \"\\e9a6\";\n}\n\n.hubicon-video_camera_front1:before {\n  content: \"\\e9a7\";\n}\n\n.hubicon-stop_circle:before {\n  content: \"\\e9a8\";\n  color: #4d5451;\n}\n\n.hubicon-photo:before {\n  content: \"\\e9a9\";\n  color: #4d5451;\n}\n\n.hubicon-diversity_3:before {\n  content: \"\\e9aa\";\n  color: #4d5451;\n}\n.hubicon-groups1:before {\n  content: \"\\e9ab\";\n  color: #4d5451;\n}\n.hubicon-person:before {\n  content: \"\\e9ac\";\n  color: #4d5451;\n}\n\n.hubicon-link_off:before {\n  content: \"\\e9ae\";\n}\n\n.hubicon-arrow_outward:before {\n  content: \"\\e9af\";\n}\n\n.hubicon-sports_and_outdoors:before {\n  content: \"\\e9b0\";\n}\n\n.hubicon-info_v2:before {\n  content: \"\\e9b2\";\n}\n\n.hubicon-deletev2:before {\n  content: \"\\e9b1\";\n  color: #4d5451;\n}\n\n.hubicon-gavel:before {\n  content: \"\\e9b3\";\n}\n\n.hubicon-dashboard_customize:before {\n  content: \"\\e9b4\";\n  color: #6ea8fe;\n}\n\n.hubicon-campaign:before {\n  content: \"\\e9b5\";\n}\n\n.hubicon-task_alt:before {\n  content: \"\\e9b6\";\n  color: #4d5451;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
